import "./NavbarLogo.css";

const NavbarLogo = () => {
  return <p className="bold navbar__logo">moja firma</p>;
};
export default NavbarLogo;
